import axios from "axios";

export const ICD_API = "icd";

export const getAllIcds = () => {
  return axios.get(`${ICD_API}`);
}

export const searchIcds = (query) => {
  return axios.get(`${ICD_API}?search=${query}`);
} 